export const getFirstAddress = (addresses: Address[]): Address => {
  const firstAddress = addresses[0];

  return firstAddress;
};
